import { render, staticRenderFns } from "./AddPurchaseInvoiceLinesModal.vue?vue&type=template&id=24b54675&scoped=true&"
import script from "./AddPurchaseInvoiceLinesModal.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseInvoiceLinesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchaseInvoiceLinesModal.vue?vue&type=style&index=0&id=24b54675&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b54675",
  null
  
)

export default component.exports